import React from "react";
import { msgid, ngettext, t } from "ttag";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { SearchPagination } from "../components/SearchPagination";
import { SearchResults } from "../components/SearchResults";
import { Themed } from "../styles/themes";

import styles from "../styles/search-results-page-2026.module.scss";

export const Template = (props: templates.SearchResultsTemplate) => (
    <PageSkeleton
        title={t`Search Results`}
        language={props.language}
        alternate_pages={[]}
    >
        <Themed theme="offWhite">
            <div className={styles.inner}>
                <h1 className={styles.heading}>
                    {ngettext(
                        msgid`${props.total_count} Result for \u2018${props.query}\u2019`,
                        `${props.total_count} Results for \u2018${props.query}\u2019`,
                        props.total_count,
                    )}
                </h1>
                <SearchResults results={props.results} />
                <SearchPagination
                    query={props.query}
                    currentPage={props.current_page}
                    totalPages={props.total_pages}
                />
            </div>
        </Themed>
    </PageSkeleton>
);
